import React, {Fragment} from 'react'
import styles from './ErrorPage.scss'
import {userIsAdmin} from 'lib/utils'
import {StandardLayout} from 'common/layouts/StandardLayout'
import {Card} from 'common/styleguide/Card'
import {CTA} from 'common/styleguide/CTA'
import {Icon} from 'common/Icon'
import {browserHistory} from 'react-router'

export class ErrorPage extends React.PureComponent {
  openZDWidget = (e) => {
    if (window.zE) {
      e.preventDefault()
      window.zE('webWidget', 'show')
      window.zE('webWidget', 'open')
    }
  }

  render () {
    const {error, errorInfo, sentryEventId} = this.props
    return (
      <StandardLayout greyBg>
        <div className={styles.ErrorPage}>
          <Card>
            <div className={styles.icon}>
              <Icon i='md-bicycle' size={50} />
            </div>
            <h2>An application error occurred.</h2>
            <p style={{marginBottom: '20px'}}>Unfortunately, something went wrong on this page and we were unable to render your content. Our developers have been notified of this error and will look into it.</p>
            <p style={{marginBottom: '20px'}}>Please try refreshing the page, and if the error persists you can submit a support ticket below.</p>
            <div>
              <CTA inline margins={false} onClick={this.openZDWidget} href='https://ridewithgps.zendesk.com/hc/en-us/requests/new'>Submit a Support Ticket</CTA>
              <CTA inline margins={false} link onClick={() => browserHistory.goBack()}>Go Back</CTA>
            </div>
          </Card>
          {userIsAdmin && <Card>
            <h2>Admin Info</h2>
            <p><strong>Sentry Event Id</strong><code><pre>{sentryEventId}</pre></code></p>
            {errorInfo && errorInfo.componentStack && <Fragment>
              <p><strong>componentStack</strong></p>
              <p><code><pre>{errorInfo.componentStack}</pre></code></p>
            </Fragment>}
            <p><strong>error.toString</strong></p>
            <p><code><pre>{error.toString()}</pre></code></p>
            {error && error.stack && <Fragment>
              <p><strong>error.stack</strong></p>
              <p><code><pre>{error.stack}</pre></code></p>
            </Fragment>}
          </Card>}
        </div>
      </StandardLayout>
    )
  }
}
